import { FormattedMessage } from 'react-intl';

import { StaticModal, useModal } from '@/modules/modals';
import { Button, Icon } from '@/modules/ui';

import type { VaultFormModalData } from '../../types';

// Opens the shared vault form with no payload, which the form reads as create.
export const AddVaultButton = () => {
    const { updateModal } = useModal<VaultFormModalData>(StaticModal.VAULT_FORM);

    return (
        <Button
            type='primary'
            icon={<Icon type='add' />}
            size='large'
            data-testid='add-vault-button'
            onClick={() => {
                updateModal(true, {});
            }}
        >
            <FormattedMessage id='vaults.actions.create' />
        </Button>
    );
};
